/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesReferentialDto } from './FeesReferentialDto';
import {
    FeesReferentialDtoFromJSON,
    FeesReferentialDtoFromJSONTyped,
    FeesReferentialDtoToJSON,
    FeesReferentialDtoToJSONTyped,
} from './FeesReferentialDto';

/**
 * 
 * @export
 * @interface AdjustmentsConfigDto
 */
export interface AdjustmentsConfigDto {
    /**
     * 
     * @type {string}
     * @memberof AdjustmentsConfigDto
     */
    borrowerCommission: string;
    /**
     * 
     * @type {Array<FeesReferentialDto>}
     * @memberof AdjustmentsConfigDto
     */
    fees: Array<FeesReferentialDto>;
    /**
     * 
     * @type {string}
     * @memberof AdjustmentsConfigDto
     */
    modeLissageFraisIntermediation?: string;
}

/**
 * Check if a given object implements the AdjustmentsConfigDto interface.
 */
export function instanceOfAdjustmentsConfigDto(value: object): value is AdjustmentsConfigDto {
    if (!('borrowerCommission' in value) || value['borrowerCommission'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    return true;
}

export function AdjustmentsConfigDtoFromJSON(json: any): AdjustmentsConfigDto {
    return AdjustmentsConfigDtoFromJSONTyped(json, false);
}

export function AdjustmentsConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdjustmentsConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerCommission': json['borrowerCommission'],
        'fees': ((json['fees'] as Array<any>).map(FeesReferentialDtoFromJSON)),
        'modeLissageFraisIntermediation': json['modeLissageFraisIntermediation'] == null ? undefined : json['modeLissageFraisIntermediation'],
    };
}

export function AdjustmentsConfigDtoToJSON(json: any): AdjustmentsConfigDto {
    return AdjustmentsConfigDtoToJSONTyped(json, false);
}

export function AdjustmentsConfigDtoToJSONTyped(value?: AdjustmentsConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerCommission': value['borrowerCommission'],
        'fees': ((value['fees'] as Array<any>).map(FeesReferentialDtoToJSON)),
        'modeLissageFraisIntermediation': value['modeLissageFraisIntermediation'],
    };
}

